import Nullstack from 'nullstack';
export default function IconLogicXnor({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-logic-xnor",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M22 12h-2"
  }), "   ", Nullstack.element("path", {
    d: "M2 9h4"
  }), "   ", Nullstack.element("path", {
    d: "M2 15h4"
  }), "   ", Nullstack.element("path", {
    d: "M5 19c1.778 -4.667 1.778 -9.333 0 -14"
  }), "   ", Nullstack.element("path", {
    d: "M8 5c10.667 2.1 10.667 12.6 0 14c1.806 -4.667 1.806 -9.333 0 -14z"
  }), "   ", Nullstack.element("circle", {
    cx: "18",
    cy: "12",
    r: "2"
  }), " ");
}